import { render, staticRenderFns } from "./ContentTableBreadcrumbs.vue?vue&type=template&id=b08b9304&scoped=true&"
import script from "./ContentTableBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ContentTableBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08b9304",
  null
  
)

export default component.exports